export const UPDATE_PPP_OBJECT_PENDING = 'update_ppp_object_pending';
export const UPDATE_PPP_OBJECT_RECEIVED = 'update_ppp_object_received';
export const UPDATE_PPP_OBJECT_ERROR = 'update_ppp_object_error';
